import { createRouter, createWebHashHistory } from 'vue-router'
import athWyCho from '@/views/01/athWyCho.vue'
import cellAth from '@/views/02/cellAth.vue'
import kakaoAth from '@/views/02/kakaoAth.vue'
import naverAth from '@/views/02/naverAth.vue'
import jntAthdcAth from '@/views/02/jntAthdcAth.vue'
import fncAthdc from '@/views/02/fncAthdc.vue'
import ctrBasMttCnf from '@/views/03/ctrBasMttCnf.vue'
import ctrLstCho from '@/views/03/ctrLstCho.vue'
import cfntYnCnf from '@/views/04/cfntYnCnf.vue'
import acntInfInp from '@/views/05/acntInfInp.vue'
import sbcpDocSgn from '@/views/05/sbcpDocSgn.vue'
import sgnInpNdMainMttCnf from '@/views/06/sgnInpNdMainMttCnf.vue'
import fingerPrintAth from '@/views/07/fingerPrintAth.vue'
import ctrDocCnf from '@/views/07/ctrDocCnf.vue'
import cmpltSal from '@/views/08/cmpltSal.vue'
import cfntChnChngPrctr from '@/views/redirect/cfntChnChngPrctr.vue'
import sessionExpired from '@/views/etc/sessionExpired.vue'
import usePrdExpired from '@/views/redirect/usePrdExpired.vue'
import elcSgnComp from '@/views/redirect/elcSgnComp.vue'
import cmpltSalComp from '@/views/redirect/cmpltSalComp.vue'

import useDialog from '@/common/dialog'
const routes = [
  // 1 인증방식 선택
  {
    path: '/',
    name: 'athWyCho',
    component: athWyCho,
  },
  // 2-1 휴대폰 인증
  {
    path: '/cellAth',
    name: 'cellAth',
    component: cellAth,
  },
  // 2-2 카카오 인증
  {
    path: '/kakaoAth',
    name: 'kakaoAth',
    component: kakaoAth,
  },
  // 2-3 네이버 인증
  {
    path: '/naverAth',
    name: 'naverAth',
    component: naverAth,
  },
  // 2-4 공인인증서 인증
  {
    path: '/jntAthdcAth',
    name: 'jntAthdcAth',
    component: jntAthdcAth,
  },
  //2-5 금융인증서 인증
  {
    path: '/fncAthdc',
    name: 'fncAthdc',
    component: fncAthdc,
  },
  // 3-1 단건 계약정보조회
  {
    path: '/ctrBasMttCnf',
    name: 'ctrBasMttCnf',
    component: ctrBasMttCnf,
  },
  // 3-2 계약 선택 ( 대표앱에서 들어온 경우 )
  {
    path: '/ctrLstCho',
    name: 'ctrLstCho',
    component: ctrLstCho,
  },
  // 4 대면서명
  {
    path: '/cfntYnCnf',
    name: 'cfntYnCnf',
    component: cfntYnCnf,
  },
  // 5-1 계좌정보입력
  {
    path: '/acntInfInp',
    name: 'acntInfInp',
    component: acntInfInp,
  },
  // 5-2 청약서류서명
  {
    path: '/sbcpDocSgn',
    name: 'sbcpDocSgn',
    component: sbcpDocSgn,
  },
  // 6 서명입력 및 주요사항확인
  {
    path: '/sgnInpNdMainMttCnf',
    name: 'sgnInpNdMainMttCnf',
    component: sgnInpNdMainMttCnf,
  },
  // 7 지문인증
  {
    path: '/fingerPrintAth',
    name: 'fingerPrintAth',
    component: fingerPrintAth,
  },
  // 7 계약서류확인
  {
    path: '/ctrDocCnf',
    name: 'ctrDocCnf',
    component: ctrDocCnf,
  },
  // 8 완전판매
  {
    path: '/cmpltSal',
    name: 'cmpltSal',
    component: cmpltSal,
  },

  // ***** etc ***** //
  // 세션 만료 ( "비정상적인 방법으로 접속하셨습니다." 메시지 안내.)
  // redirect 대면건으로 변경된 전자서명 일 경우
  {
    path: '/cfntChnChngPrctr',
    name: 'cfntChnChngPrctr',
    component: cfntChnChngPrctr,
  },
  {
    path: '/sessionExpired',
    name: 'sessionExpired',
    component: sessionExpired,
  },
  // 사용기한 만료
  {
    path: '/usePrdExpired',
    name: 'usePrdExpired',
    component: usePrdExpired,
  },
  // 전자서명 완료
  {
    path: '/elcSgnComp',
    name: 'elcSgnComp',
    component: elcSgnComp,
  },
  {
    path: '/cmpltSalComp',
    name: 'cmpltSalComp',
    component: cmpltSalComp,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
})

router.beforeEach(async (to, from) => {
  if (from.name == 'sgnInpNdMainMttCnf' && to.name == 'sbcpDocSgn') {
    let dialog = useDialog()
    let data = await dialog.confirm(
      '뒤로가기시 확인(서명입력)완료한 문서목록이 초기화됩니다. 이동하시겠습니까?'
    )
    if (data == '1') {
      return true
    } else if (data == '2') {
      return false
    }
  } else return true
})
export default router
